function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,61H22a6,6,0,0,1-6-6V22l9-11H50a6,6,0,0,1,6,6V55A6,6,0,0,1,50,61Z",
    style: {
      fill: "#599def"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,20.556A1.444,1.444,0,0,1,23.556,22H16l9-11h0Z",
    style: {
      fill: "#c2e1ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 18,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 46,
    width: 12,
    height: 2,
    rx: 1,
    ry: 1,
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.da4f05d93f6ae999ea6882b49679da84.svg";
export { ForwardRef as ReactComponent };